import { render, staticRenderFns } from "./MultimediaGallery.vue?vue&type=template&id=8db4e9ac&scoped=true&"
import script from "./MultimediaGallery.vue?vue&type=script&lang=js&"
export * from "./MultimediaGallery.vue?vue&type=script&lang=js&"
import style0 from "./MultimediaGallery.vue?vue&type=style&index=0&id=8db4e9ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8db4e9ac",
  null
  
)

export default component.exports